import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
    return (
        <LegalPage
            testid="page-privacy"
            title="Privacy Policy"
            subtitle="How AudRI collects, processes and safeguards customer data."
            lastUpdated="21 April 2026"
        >
            <p>
                This Privacy Policy describes how AudRI ("we", "our") processes
                personal data when you use our SaaS platform. AudRI is a B2B service
                for automating GxP audits in life sciences; the bulk of data we
                process is regulated customer content submitted by authorised users
                at our enterprise customers.
            </p>

            <h2>1. Data we process</h2>
            <ul>
                <li>
                    <strong>Account data:</strong> name, work email, organisation,
                    role, authentication metadata.
                </li>
                <li>
                    <strong>Customer content:</strong> SOPs, URS, IQ/OQ/PQ, change
                    controls, deviations and any documents you upload for audit.
                </li>
                <li>
                    <strong>Audit outputs:</strong> extracted rules, requirements,
                    traceability matrices, findings, CAPAs and e-signatures.
                </li>
                <li>
                    <strong>Operational logs:</strong> IP address, user agent, audit
                    trail of actions performed in the platform.
                </li>
            </ul>

            <h2>2. Purposes and legal basis</h2>
            <p>
                We process the data above to provide the service (performance of a
                contract), to keep it secure (legitimate interest) and to comply with
                legal obligations — including 21 CFR Part 11 audit-trail
                requirements.
            </p>

            <h2>3. Sub-processors</h2>
            <p>
                AudRI uses a limited set of sub-processors to operate the service
                (cloud hosting, managed database, AI inference, object storage, email
                delivery). {"{{TODO: insert current sub-processor list — vendor, role, region}}"}.
            </p>

            <h2>4. International transfers</h2>
            <p>
                {"{{TODO: describe transfer mechanism — Standard Contractual Clauses, UK IDTA, regional data residency options.}}"}
            </p>

            <h2>5. Retention</h2>
            <p>
                Customer content is retained for the duration of the subscription and
                deleted within 30 days of termination unless a longer period is
                required by law or by the customer's GxP records retention policy.
            </p>

            <h2>6. Security</h2>
            <ul>
                <li>Encryption in transit (TLS 1.2+) and at rest.</li>
                <li>
                    Role-based access control (QA Auditor, QA Manager, Admin,
                    Observer, System Owner).
                </li>
                <li>
                    21 CFR Part 11–style audit trail: every mutation is recorded with
                    user, timestamp, and action.
                </li>
                <li>SHA-256 integrity hashing for every uploaded document.</li>
            </ul>

            <h2>7. Your rights</h2>
            <p>
                You may request access, rectification, deletion, restriction, or
                portability of personal data relating to you. End-user rights are
                generally exercised through the Admin at your organisation; we assist
                our customers in fulfilling them.
            </p>

            <h2>8. Contact</h2>
            <p>
                Data Protection Officer · {"{{TODO: name}}"} ·{" "}
                <a href="mailto:privacy@audri.app">privacy@audri.app</a>.
            </p>
        </LegalPage>
    );
}
